var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogoV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 163.544,
    viewBox: "0 0 192 163.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(-555.054 -428.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(555.054 428.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bottom_Swish",
    "data-name": "Bottom Swish",
    d: "M781.782,1018.61a74.977,74.977,0,0,0,43.108,13.553c42.6,0,56.41-34.2,76.676-41.967-19.673-3.385-37.933,9.453-57.184,20.863-20.055,11.629-41.819,13.812-62.6,7.551Z",
    transform: "translate(-732.864 -868.619)",
    fill: "#02245a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_Swish",
    "data-name": "Top Swish",
    d: "M632.377,837.5a75,75,0,0,0,16.585,47.156c23.953,13.822,50.478,14.857,74.639.844,28.926-16.771,53.134-35.027,84.093-11.918-31.314-59.232-75.516-8.74-110.33-4.779-27.213,3.1-58.293-6.318-64.986-31.3Z",
    transform: "translate(-615.694 -749.305)",
    fill: "#02245a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stars",
    d: "M919.816,622.594l1.8,5.854,5.858,1.8-5.858,1.8-1.8,5.855-1.8-5.855-5.855-1.8,5.855-1.8Zm-75.011-38.963,2.587,8.417,8.421,2.585-8.421,2.588-2.587,8.42-2.585-8.42-8.418-2.588,8.418-2.585Z",
    transform: "translate(-773.661 -550.206)",
    fill: "#e6be12",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stars-2",
    "data-name": "Stars",
    d: "M757.645,563l1.8,5.853,5.858,1.8-5.858,1.8-1.8,5.854-1.8-5.854-5.855-1.8,5.855-1.8Zm14.462,15.513,4.439,14.451L791,597.409l-14.451,4.434L772.106,616.3l-4.443-14.457-14.452-4.434,14.452-4.443ZM690.549,605.66l2,6.5,6.5,2-6.5,1.994-2,6.5-1.994-6.5-6.5-1.994,6.5-2Z",
    transform: "translate(-654.655 -534.029)",
    fill: "#e6be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Moon",
    d: "M645.8,430.584a74.153,74.153,0,0,1,51.842,43.357,74.239,74.239,0,0,0-109.281-8.4l-13.274-13.275A74.192,74.192,0,0,1,645.8,430.584Zm-68.24,47.631a74.308,74.308,0,0,0-6.727,70.495,74.334,74.334,0,0,1-5.762-82.984l9.454,9.454Z",
    transform: "translate(-555.054 -428.714)",
    fill: "#02245a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wand",
    d: "M588.463,505.335l32.68,32.7L669.928,564.8v6.044H603.906V564.8l10.666-18.6-33.206-33.169-12.8-12.784-13.379-13.369,7.409-7.415,12.595,12.6Z",
    transform: "translate(-555.157 -468.512)",
    fill: "#9f9f9f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoV2);
export default __webpack_public_path__ + "static/media/newLogoV2.76fe8afc2729b59b9b3c64b57c195381.svg";
export { ForwardRef as ReactComponent };